import React, { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { observer } from "mobx-react"

import store from "../store"
import { appStyles } from "../config/config.styles/App"
import { Styles, componentHeights } from "../config"

import { Stack, IconButton } from "@mui/material"
import { PageContainer } from "../componentsV2"
import CloseIcon from "@mui/icons-material/Close"

const styles = {
	buttonContainer: {
		...appStyles.appPadding,
		boxSizing: "border-box",
		width: "100vw",
		height: componentHeights.nav,
		justifyContent: "center",
		alignItems: "center",
		position: "fixed",
		top: "0px",
		left: "0px",
		background: "linear-gradient(0deg, rgba(256,256,256,0), white 10%) no-repeat",
		zIndex: 999,

		"*": {
			boxSizing: "border-box"
		}
	},

	buttonInnerContainer: {
		width: "100%",
		maxWidth: "1600px",
		height: componentHeights.nav,
		justifyContent: "center",
		alignItems: "flex-end"
	},

	button: {
		color: Styles.Color.danger,
		fontSize: { zero: "1.8rem", xs2: "2.1rem" }
	}
}

const Modal= ({ mounted, children, sx }) => {
	const { modalStatus, alertStatus } = store.util
	const location = useLocation()
	const navigate = useNavigate()

	function handleClose(event) {
		event.stopPropagation()
		const closeButton = document.getElementById("form-close-button")

		if (closeButton) closeButton.click()
		else navigate(-1)
	}

	function handleEsc(event) {
		event.stopPropagation()

		if (event.keyCode === 27 && !alertStatus) {
			event.preventDefault()
			handleClose(event)
		}
	}

	useEffect(() => {
		if (modalStatus) store.setNotification("modal", true)
		window.addEventListener("keydown", handleEsc)

		return () => {
			if (modalStatus) store.setNotification("modal", false)
			window.removeEventListener("keydown", handleEsc)
		}
	}, [location.pathname, alertStatus])

	return (
		<PageContainer mounted={mounted === true ? true : mounted === false ? false : true} sx={sx}>
			<Stack sx={styles.buttonContainer}>
				<Stack sx={styles.buttonInnerContainer}>
					<IconButton id="modal-close-button" onClick={handleClose}>
						<CloseIcon sx={styles.button} />
					</IconButton>
				</Stack>
			</Stack>

			{children}
		</PageContainer>
	)
}

export default observer(Modal)
